<template>
  <div class="text-left px-6 pb-6">
    <div class="pt-10" @click="dashboard">
      <close-icon :width="'w-4'" :color="'text-nw-red'"></close-icon>
    </div>
    <div class="pt-5">
      <div class="text-2xl font-extrabold">Prohibited items</div>
    </div>
    <div class="pt-8 text-center">
      <prohibited-icon></prohibited-icon>
    </div>
    <div class="pt-6">
      <div class="text-lg text-nw-ash leading-6">
        To make sure that your parcel does not contain items that are classified as hazardous materials, dangerous
        goods, prohibited or restricted articles by local shipping regulations, please allow us to inspect your shipment
        in your presence before picking it up:
      </div>
    </div>
    <div class="pt-2 text-xs text-nw-ash">
      <div>• Cash</div>
      <div>• Gold and Other Precious metals</div>
      <div>• Drugs and Narcotics</div>
      <div>• Chemicals</div>
      <div>• Weapons and Firearms</div>
      <div>• Explosive Materials</div>
      <div>• Live animals</div>
      <div>• Illegal goods</div>
      <div>• Human Remains</div>
    </div>
    <div class="pt-5 text-xs" @click="next">
      <input-button>CONTINUE</input-button>
    </div>
  </div>
</template>

<script>
import CloseIcon from '@/components/icons/CloseIcon.vue'
import ProhibitedIcon from '@/components/icons/ProhibitedIcon.vue'
import InputButton from '@/components/inputs/InputButton.vue'
export default {
  components: { CloseIcon, ProhibitedIcon, InputButton },
  methods: {
    dashboard() {
      this.$router.push({
        name: 'Dashboard'
      })
    },
    next() {
      this.$emit('show-who', true)
    }
  }
}
</script>
